import { Link } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import Loader from "./Loader";

//logo component
const Logo = ({logo}) => {
  const [loading, setLoading] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);
  const logoRef = useRef(null);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setScrollTop(window.scrollY);
    });
  }, []);

  const handleLogoClick = () => {
    setLoading(true);
    window.scrollTo({ top: logoRef.current.offsetTop - 100, behavior: 'smooth' });
    // setTimeout(() => {
      setLoading(false);
    // }, 200); // adjust the timeout value as needed
  };


    return(
      <>
      <Link className="logo navbar-brand" to='/' onClick={handleLogoClick}>
        <img ref={logoRef} className="logo " src={logo}></img>
        {loading && <Loader></Loader>}
      </Link>
      </>
    );
}
  
export default Logo;